import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import PrivateRoute from "components/authentication/PrivateRoute";
import ScrollToTop from "components/common/ScrollToTop";

import HomePage from "components/main/home/HomePage";
import ProfilePage from "components/authentication/profile/ProfilePage";
import UnderConstruction from "components/common/UnderConstruction";
import NotFoundPage from "components/common/NotFoundPage";
import NotPermittedPage from "components/common/NotPermittedPage";

import {PermissionTypes} from "../components/authentication/permissionsGroups";

import UtentiPage from "components/authentication/utenti/UtentiPage";
import UtentePage from "components/authentication/utenti/UtentePage";
import SignIn from "components/authentication/SignIn";
import ChangePassword from "components/authentication/ChangePasswordPage";
import ForgotPassword from "components/authentication/ForgotPassword";
import ResetPasswordPage from "components/authentication/ResetPasswordPage";
import WellComePage from "components/authentication/WellComePage";
import TicketsPage from "components/ticketing/TicketsPage";
import EsempioFormAutocomplete from "./common/esempi/EsempioFormAutocomplete";
import PrevisioniPage from "./main/pianificazione/previsioni/PrevisioniPage";
import PrevisionePage from "./main/pianificazione/previsioni/previsione/PrevisionePage";
import BudgetsPage from "./main/pianificazione/budgets/BudgetsPage";
import OrdiniLavoroPage from "./main/produzione/ordiniLavoro/OrdiniLavoroPage";
import OrdineLavoroPage from "./main/produzione/ordiniLavoro/ordineLavoro/OrdineLavoroPage";
import AssegnazioniGanttPage
    from "./main/produzione/ordiniLavoro/ordineLavoro/assegnazioni/gantt/AssegnazioniGanttPage";

export enum Routes_path {
    HOME = "/",
    SIGNIN = "/signin/",
    WELL_COME = "/well_come/:uidb64/:token/",
    FORGOT_PASSWORD = "/forgotPassword/",
    RESET_PASSWORD = "/resetPassword/:uidb64/:token/",
    UNDER_COSTRUCTION = "/UnderConstruction/",
    UTENTI = "/utenti/",
    UTENTE = "/utente/",
    TICKETING = "/tickets/",
    ESEMPIO = "/esempio/",
    PREVISIONI = "/previsioni/",
    PREVISIONE = "/previsione/",
    BUDGETS = "/budgets/",
    ORDINI_LAVORO="/ordini_lavoro/",
    ORDINE_LAVORO="/ordine_lavoro/",
    ASSEGNAZIONI_GANTT="/assegnazioni_gantt/",
}

const RouterApp = () => {

    const isMaintenanceMode = false;
    if (isMaintenanceMode) {
        return <Navigate to={Routes_path.UNDER_COSTRUCTION} replace/>;
    }

    return (
        <ScrollToTop>
            <Routes>
                <Route path={Routes_path.HOME} element={<HomePage/>}/>
                <Route path={Routes_path.SIGNIN} element={<SignIn/>}/>
                {/* <Route  path={"/register/"} element={Register} /> */}
                <Route path={Routes_path.WELL_COME} element={<WellComePage/>}/>
                <Route
                    path={Routes_path.FORGOT_PASSWORD}
                    element={<ForgotPassword/>}
                />
                <Route path={Routes_path.RESET_PASSWORD} element={<ResetPasswordPage/>}/>
                {/* <Route
					path={Routes_path.UNDER_COSTRUCTION}
					element={<UnderConstruction />}
				/> */}

                <Route
                    path={Routes_path.PREVISIONE + ":previsione_id"}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<PrevisionePage/>}
                        />
                    }
                />

                <Route
                    path={Routes_path.PREVISIONE}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<PrevisionePage/>}
                        />
                    }
                />

                <Route
                    path={Routes_path.PREVISIONI}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<PrevisioniPage/>}
                        />
                    }
                />

                <Route
                    path={Routes_path.ORDINE_LAVORO + ":ordine_lavoro_id"}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<OrdineLavoroPage/>}
                        />
                    }
                />

                {/*<Route*/}
                {/*    path={Routes_path.ORDINE_LAVORO}*/}
                {/*    element={*/}
                {/*        <PrivateRoute*/}
                {/*            gruppiAutorizzati={[PermissionTypes.ALL]}*/}
                {/*            element={<OrdineLavoroPage/>}*/}
                {/*        />*/}
                {/*    }*/}
                {/*/>*/}

                <Route
                    path={Routes_path.ORDINI_LAVORO}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<OrdiniLavoroPage/>}
                        />
                    }
                />

                <Route
                    path={Routes_path.BUDGETS}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<BudgetsPage/>}
                        />
                    }
                />


                <Route
                    path={Routes_path.ASSEGNAZIONI_GANTT}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<AssegnazioniGanttPage/>}
                        />
                    }
                />


                <Route
                    path={Routes_path.UNDER_COSTRUCTION}
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.GRUPPO_UNDERCONSTRUCTION]}
                            element={<UnderConstruction/>}
                        />
                    }
                />


                <Route
                    path="/me"
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<ProfilePage/>}
                        />
                    }
                />
                <Route
                    path="/me/changepassword"
                    element={
                        <PrivateRoute
                            gruppiAutorizzati={[PermissionTypes.ALL]}
                            element={<ChangePassword/>}
                        />
                    }
                />

				{/*<Route*/}
				{/*	path={Routes_path.TICKETING}*/}
				{/*	element={*/}
				{/*		<PrivateRoute*/}
				{/*			gruppiAutorizzati={[PermissionTypes.TICKETING_ASSISTENZA]}*/}
				{/*			element={<TicketsPage />}*/}
				{/*		/>*/}
				{/*	}*/}
				{/*/>*/}

                <Route path="/notPermitted" element={<NotPermittedPage/>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </ScrollToTop>
    );
};

export default RouterApp;
